import * as z from "zod/v4";

/**
 * Upload merchant-authored TypeScript source as an artifact bound to an
 * extension contract. The server verifies the artifact (size + TS type-check
 * against the contract's input universe pruned by inputSelector) and stores
 * it; the caller sets the returned artifactId on whichever flow step or other
 * host resource references it.
 *
 * Errors surface as RpcError BadRequest with the structured verifier message
 * (size limit, type-check diagnostics, or selector-references-unknown-field).
 */
export const uploadExtensionArtifact = {
  name: "uploadExtensionArtifact" as const,
  input: z.object({
    contractId: z.string(),
    code: z.string(),
    inputSelector: z.array(z.string()),
  }),
  output: z.object({ artifactId: z.string() }),
};
